export const validateData = async (values = {}, schema) => {
    try {
        if (
            !schema ||
            typeof schema !== "object" ||
            Object.keys(schema)?.length < 1
        ) {
            return {
                status: true,
                message: "Validation not provided",
                data: values,
            };
        }

        const errors = {};
        const result = {};

        const toNumber = (v) => {
            if (v === null || v === undefined || v === "") return null;
            const n = Number(v);
            return Number.isFinite(n) ? n : NaN;
        };

        const toBoolean = (v) => {
            if (typeof v === "boolean") return v;
            if (v === undefined || v === null || v === "") return null;
            if (v === "true" || v === "1" || v === 1) return true;
            if (v === "false" || v === "0" || v === 0) return false;
            return null;
        };

        for (const field in schema) {
            const rules = schema[field] || {};
            const raw = values?.[field];

            // Required check
            const isEmpty = raw === undefined || raw === null || raw === "";
            if (rules.required && isEmpty) {
                errors[field] = {
                    field,
                    message: `${field.replace(/_/g, " ")} is required`,
                };
                continue;
            }

            if (isEmpty) {
                if ("default" in rules) result[field] = rules.default;
                else
                    result[field] =
                        rules.type === "number" || rules.type === "boolean"
                            ? null
                            : "";
                continue;
            }

            let value = raw;
            if (rules.type === "string") {
                value = typeof value === "string" ? value : String(value);
                if (rules.trim) value = value.trim();
                if (rules.required && !value) {
                    errors[field] = {
                        field,
                        message: `${field.replace(/_/g, " ")} is required`,
                    };
                    continue;
                }
                result[field] = value;
            } else if (rules.type === "number") {
                const n = rules.coerce
                    ? toNumber(value)
                    : typeof value === "number"
                    ? value
                    : NaN;
                if (n === null || Number.isNaN(n)) {
                    errors[field] = {
                        field,
                        message: `${field.replace(/_/g, " ")} must be a number`,
                    };
                    continue;
                }
                if (typeof rules.min === "number") {
                    if (
                        rules.exclusiveMin
                            ? !(n > rules.min)
                            : !(n >= rules.min)
                    ) {
                        errors[field] = {
                            field,
                            message: `${field.replace(/_/g, " ")} must be ${
                                rules.exclusiveMin ? "greater than" : "at least"
                            } ${rules.min}`,
                        };
                        continue;
                    }
                }
                result[field] = n;
            } else if (rules.type === "boolean") {
                const b = rules.coerce
                    ? toBoolean(value)
                    : typeof value === "boolean"
                    ? value
                    : null;
                if (b === null) {
                    errors[field] = {
                        field,
                        message: `${field.replace(
                            /_/g,
                            " "
                        )} must be a boolean`,
                    };
                    continue;
                }
                result[field] = b;
            } else {
                // Unsupported type
                result[field] = value;
            }
        }

        // Cross-field validations
        for (const field in schema) {
            const rules = schema[field] || {};
            if (rules.greaterThanField) {
                const left = result[field];
                const right = result[rules.greaterThanField];
                if (left !== null && right !== null && !(left > right)) {
                    errors[field] = {
                        field,
                        message: `${field.replace(
                            /_/g,
                            " "
                        )} must be greater than ${rules.greaterThanField.replace(
                            /_/g,
                            " "
                        )}`,
                    };
                }
            }
        }

        if (
            typeof errors === "object" &&
            Object.keys(errors || {})?.length > 0
        ) {
            return {
                status: false,
                message: "Validation failed",
                data: { errors },
            };
        }

        return { status: true, message: "OK", data: result };
    } catch (error) {
        return {
            status: false,
            message: error?.message || "Invalid data",
            data: error,
        };
    }
};
